import React, { FunctionComponent, useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import useAlertStore from '../store/alert';
import { errorMessage } from '../utils';
import { Button } from './inputs/button';

/**
 * Alert props
 */
interface Props {}

/**
 * Alert Component
 */
const Alert: FunctionComponent<Props> = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const { show, title, message, buttons, setAlertState } = useAlertStore();

  useEffect(() => {
    if (!show) {
      setLoading(false);
    }
  }, [show]);

  if (!show) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black/[0.5] z-10 items-center justify-center flex">
      <div className="bg-white p-5 rounded flex flex-col gap-2 w-full max-w-[400px]">
        <h5 className="text-blue text-3xl font-bold mb-2">{title}</h5>
        {message?.split('\n').map(paragraph => (
          // @ts-ignore
          <p key={paragraph}>{ReactHtmlParser(paragraph)}</p>
        ))}
        <div className="flex flex-row justify-end items-center gap-2 mt-5">
          {buttons?.map(({ text, ...button }, btnIndex) => (
            <Button
              {...button}
              // eslint-disable-next-line react/no-array-index-key
              key={`alert-index-${btnIndex}`}
              loading={loading}
              onClick={async () => {
                setLoading(true);
                try {
                  if (button.onClick) {
                    await button.onClick();
                  }
                } catch (err) {
                  // eslint-disable-next-line no-console
                  console.log('error in alert action', errorMessage(err));
                }
                setAlertState({
                  show: false,
                  title: undefined,
                  message: undefined,
                  buttons: undefined,
                });
              }}
              style={{
                ...(button?.style || {}),
                padding: 48.5,
                paddingTop: 12,
                paddingBottom: 12,
              }}>
              {text}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Alert;
